module.exports = require("@splunk/dashboard-visualizations/ChoroplethSvg");